import tabletService from '@/api/tablet'
import { TABLETS } from '../types'

export default {
  namespaced: true,
  state: {
    tablets: [],
    tabletId: null
  },
  mutations: {
    [TABLETS.TABLETS_SET](state, tablets) {
      state.tablets = tablets
    },
    [TABLETS.SET_ID](state, id) {
      state.tabletId = id
    }
  },
  actions: {
    getTablet: function ({ dispatch }, id) {
      dispatch('Global/showLoading', null, { root: true })
      return new Promise((resolve, reject) => {
        tabletService.getTablet(id).then((response) => {
          dispatch('Global/hideLoading', null, { root: true })
          resolve(response.data)
        }).catch((error) => {
          dispatch('Global/hideLoading', null, { root: true })
          reject(error)
        })
      })
    },
    getTablets: function ({ dispatch, commit }) {
      dispatch('Global/showLoading', null, { root: true })
      return new Promise((resolve, reject) => {
        tabletService.getTablets().then((response) => {
          commit(TABLETS.TABLETS_SET, response.data)
          resolve()
        }).catch((error) => {
          reject(error)
        }).finally(() => {
          dispatch('Global/hideLoading', null, { root: true })
        })
      })
    },
    deleteTablet: function ({ dispatch }, id) {
      dispatch('Global/showLoading', null, { root: true })
      return new Promise((resolve, reject) => {
        tabletService.deleteTablet(id).then(() => {
          dispatch('Global/hideLoading', null, { root: true })
          resolve()
        }).catch((error) => {
          dispatch('Global/hideLoading', null, { root: true })
          reject(error)
        })
      })
    },
    createTablet: function ({ dispatch }, tablet) {
      dispatch('Global/showLoading', null, { root: true })
      return new Promise((resolve, reject) => {
        tabletService.createTablet(tablet).then(() => {
          dispatch('Global/hideLoading', null, { root: true })
          resolve()
        }).catch((error) => {
          dispatch('Global/hideLoading', null, { root: true })
          reject(error)
        })
      })
    },
    editTablet: function ({ dispatch }, tablet) {
      dispatch('Global/showLoading', null, { root: true })
      return new Promise((resolve, reject) => {
        tabletService.updateTablet(tablet).then(() => {
          dispatch('Global/hideLoading', null, { root: true })
          resolve()
        }).catch((error) => {
          dispatch('Global/hideLoading', null, { root: true })
          reject(error)
        })
      })
    },
    setTabletId({ commit }, id) {
      commit(TABLETS.SET_ID, id)
    },
  }
}
